import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getTestimonials,
  deleteTestimonial,
  getNextTestimonials,
  getPreviousTestimonials,
} from "../../store/actions/testimonials_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/testimonials_enum";
import DataTable from "../../components/common/DataTable";
const AllTestimonials = ({
  getTestimonials,
  deleteTestimonial,
  getNextTestimonials,
  getPreviousTestimonials,
  testimonial: { loading, testimonials },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteTestimonial(deleteEntry);
      }
      getTestimonials({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (testimonials && testimonials.length === LIMIT) {
      const lastTestimonial = testimonials[testimonials.length - 1];
      getNextTestimonials({ last: lastTestimonial });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastTestimonial = testimonials[0];
      getPreviousTestimonials({
        first: lastTestimonial,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getTestimonials({ term: term, termField: termField });
    }
  };
  const deleteTestimonialClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getTestimonials({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Testimonials"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Testimonial"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="testimonials" title="Testimonial" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={testimonials}
                      field={"testimonials"}
                      page={page}
                      deleteBtnClicked={deleteTestimonialClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={testimonials}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ testimonial: state.testimonial });

const mapDispatchToProps = {
  getTestimonials,
  deleteTestimonial,
  getNextTestimonials,
  getPreviousTestimonials,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllTestimonials);
